"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var Body = function Body(_ref) {
  var content = _ref.content;
  if (!content) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hide-version"
  }, (0, _htmlReactParser.default)(content));
};
var _default = Body;
exports.default = _default;
Body.propTypes = {
  /**
   * CaaS body content.
   */
  content: _propTypes.default.string
};
Body.defaultProps = {
  content: ''
};